import React from 'react';

import classNames from 'classnames';

import { ReactComponent as ExternalLinkIcon } from '../../assets/images/icons/ExternalLink.svg';
import { ExternalLink } from '../ExternalLink';
import { InternalLink } from '../InternalLink';

import * as classes from './style.module.scss';

interface Props {
  anchor?: boolean;
  title: string;
  path: string;
  active?: boolean;
  onClick?(): void;
}

export const NavigationItem: React.FC<Props> = ({
  anchor,
  title,
  path,
  active = false,
  onClick,
}) => {
  return (
    <li className={classes.root}>
      {anchor || path.startsWith('http') ? (
        <ExternalLink href={path} className={classes.link}>
          {title}
          <ExternalLinkIcon />
        </ExternalLink>
      ) : (
        <InternalLink
          className={classNames(classes.link, { [classes.active]: active })}
          to={path}
          onClick={onClick}
          aria-current={active ? 'page' : undefined}
        >
          {title}
        </InternalLink>
      )}
    </li>
  );
};
